"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InitiateTransformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="237698" id="initiate-transformation" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div ref={ref} className={`relative overflow-hidden rounded-md bg-background px-6 py-16 md:py-24 text-center shadow-4xl transition-all duration-1000 ease-out border border-white/10 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="absolute inset-0 pointer-events-none overflow-hidden">
            <svg className="absolute bottom-0 left-0 w-full h-auto text-primary/5 transform translate-y-1/4" viewBox="0 0 1440 320" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
              <path fill="currentColor" d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,122.7C672,96,768,96,864,117.3C960,139,1056,181,1152,186.7C1248,192,1344,160,1392,144L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
            <svg className="absolute top-0 left-0 w-full h-auto text-secondary/5 transform -translate-y-1/4 rotate-180" viewBox="0 0 1440 320" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
              <path fill="currentColor" d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,122.7C672,96,768,96,864,117.3C960,139,1056,181,1152,186.7C1248,192,1344,160,1392,144L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>

          {}
          <div className="relative z-10 flex flex-col items-center justify-center space-y-8">
            <div className="inline-flex items-center justify-center rounded-md bg-primary/10 px-4 py-1.5 backdrop-blur-md mb-4 border border-primary/20">
              <Sparkles className="mr-2 h-4 w-4 text-primary" />
              <span className="text-sm font-mono font-medium text-primary uppercase tracking-widest">
                Future-Proof Your Infrastructure
              </span>
            </div>
            
            <h2 className="font-default text-4xl md:text-6xl lg:text-8xl font-bold tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-foreground via-foreground to-foreground hover:from-primary hover:to-secondary transition-all duration-500 max-w-4xl mx-auto leading-tight uppercase">
              READY FOR THE APEX?
            </h2>
            
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto font-default">
              Scale your operations with custom software, elite cybersecurity, and AI-driven automation designed for the next generation of business.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4 w-full sm:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl text-base h-14 px-10 rounded-md transition-all duration-300 hover:scale-105 font-default font-bold uppercase tracking-wider">
                <Link to="/ConnectPage">
                  Initiate Transformation
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-2 border-muted text-foreground hover:bg-accent hover:text-accent-foreground bg-transparent text-base h-14 px-10 rounded-md transition-all duration-300 font-default">
                <Link to="/SolutionsPage">
                  Explore Solutions
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}